import { useQuery } from 'react-query'
import useAxios from './useAxios'

const useActivityReport = () => {
	const { getActivityReport } = useAxios()
	const { isLoading, data } = useQuery('rapportsActivite', getActivityReport)

	if (isLoading) return { isLoading }

	const { title, content } = data

	return {
		isLoading,
		title,
		content,
	}
}

export default useActivityReport
